<template>
    <b-modal
        id="edit-sub-assignment-name"
        title="Bewerk deelopdracht"
        :ok-title="'Opslaan'"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        size="md"
        @ok="onOk"
        @show="onShow"
        modal-class="apprentice-default-modal">
        <div class="update-sub-assignment-title">
            <b-alert
                v-if="hasError"
                variant="danger"
                show>
                {{ errorMessage }}
            </b-alert>
            <b-form-group
                label="Naam"
                label-for="sub-assignment-title-input">
                <b-form-input
                    id="sub-assignment-title-input"
                    v-model="name"
                    placeholder="Typ hier de naam van de deelopdracht">
                </b-form-input>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-assignment-edit-sub-assignment-title-edit-modal-component',
    props: {
        subAssignmentIn: {
            type: Object,
            required: true,
        },
        groupIn: {
            type: Object,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            name: this.subAssignmentIn.name,
            hasError: false,
            errorMessage: '',
        };
    },
    watch: {
        subAssignmentIn: function (value) {
            this.name = value.name;
        },
    },
    methods: {
        onShow() {
            this.name = this.subAssignmentIn.name;
            this.hasError = false;
        },

        onOk(bvModalEvent) {
            this.checkForErrors();

            if (this.hasError) {
                bvModalEvent.preventDefault();
                return;
            }

            this.alert.saving();

            const data = {
                name: this.name,
                group_id: this.groupIn ? this.groupIn.id : null,
            };

            this.axios.post(this.routes.subAssignmentUpdate(this.subAssignmentIn.id), data).then(
                (response) => {
                    if (this.groupIn) {
                        this.subAssignmentIn.update({ name: data.name });
                    }
                    this.$emit('sub-assignment-updated', response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        checkForErrors() {
            this.hasError = false;

            if (!this.name) {
                this.hasError = true;
                this.errorMessage = 'Naam deelopdracht mag niet leeg zijn.';
            }

            if (this.name && this.name.length > 192) {
                this.hasError = true;
                this.errorMessage = 'Naam deelopdracht mag niet meer dan 191 karakters bevatten.';
            }
        },
    },
};
</script>

<style scoped></style>
